import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import CloseIcon from "@mui/icons-material/Close";

// import JS files
import { AdminMenuItems } from "../admin/shares/AdminMenuItems";
import { EndUserMenuItems } from "../end-user/routes/EndUserMenuItems";
import { useAuth } from "../../context/AuthContext";
import { useUserData } from "../../context/UserDataContext.js";

// import others files
import { currentCustomer } from "../../constants/constants.js";

const TemplateNavbar = (props) => {
  const {userData} = useUserData();
  const navbarList =
    userData.job == "Admin"
      ? [...AdminMenuItems]
      : [...EndUserMenuItems];
  // const navbarList = [...EndUserMenuItems];
  const navigate = useNavigate();
  const { authDispatch } = useAuth();

  return (
    <>
      <div className="w-full h-full shadow-xl bg-mygreen-100   flex flex-col justify-between md:items-center py-4 md:py-8 px-4">
        <div>
          <div className="flex md:hidden justify-end items-center self-end">
            <CloseIcon
              fontSize="large"
              className="text-white font-bold"
              onClick={() => props.mobileToggleDrawer()}
            />
          </div>
          <div className=" flex flex-col items-center">
            <div className="bg-white w-1/5 md:w-full rounded-xl p-2">
              <img src={currentCustomer.logo} alt="" className="" />
            </div>
            <span className="text-white font-extrabold text-sm md:text-base mt-6">
            سامانه ثبت نام تکمیلی درمان
            </span>
          </div>
        </div>
        <div className=" flex flex-col w-full  mt-6 md:mt-12 flex-grow">
          {navbarList.map((item, index) => {
            return (
              <div className="menu-item" onClick={() => navigate(item.route)}>
                <item.icon
                  className={
                    props.sidebarActiveLink == item.isActive ? "text-white" : ""
                  }
                  sx={{ fontSize: "1.75rem" }}
                />
                <span
                  className={
                    props.sidebarActiveLink == item.isActive
                      ? "text-white text-sm md:text-base font-semibold mr-4"
                      : "text-sm md:text-base font-semibold mr-4"
                  }
                >
                  {item.name}
                </span>
              </div>
            );
          })}
        </div>
        <div className="flex justify-between items-center text-white w-full  justify-self-end">
          <span className="font-bold">{userData.name}</span>
          <div
            className=" cursor-pointer icon-hover"
            onClick={() => authDispatch({ type: "LOGOUT" })}
          >
            <LogoutIcon className="text-white" sx={{ fontSize: "1.75rem" }} />
          </div>
        </div>
      </div>
    </>
  );
};

export default TemplateNavbar;
